import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-white text-zinc-900 p-6">
      <div className="text-center">
        <div className="font-display font-black text-7xl tracking-tighter">404</div>
        <div className="mt-2 text-zinc-500">This page doesn&apos;t exist.</div>
        <Link to="/" className="inline-block mt-6">
          <Button className="rounded-full">Back to home</Button>
        </Link>
      </div>
    </div>
  );
}
